/* Drop countdown. Reads a shop-timezone aware target from the section. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-countdown]').forEach(function (wrap) {
    var raw = wrap.dataset.target;
    if (!raw) return;

    var target = new Date(raw);
    if (isNaN(target.getTime())) {
      /* Safari is fussy about some formats, fall back to a manual parse */
      var parts = raw.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
      if (!parts) return;
      target = new Date(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5]);
    }

    var done = wrap.parentNode.querySelector('[data-countdown-done]');
    var grid = wrap;
    var timer;

    function tick() {
      var diff = target - new Date();
      if (diff <= 0) {
        diff = 0;
        clearInterval(timer);
        if (done) {
          done.hidden = false;
          grid.hidden = true;
        }
      }
      var total = Math.floor(diff / 1000);
      var values = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60
      };
      Object.keys(values).forEach(function (key) {
        var el = wrap.querySelector('[data-' + key + ']');
        if (el) el.textContent = String(values[key]).padStart(2, '0');
      });
    }

    tick();
    timer = setInterval(tick, 1000);
  });
});
